import { useQuery } from '@tanstack/react-query';

import rateGroupService, { UngroupedRateWithDetails } from '~/services/cruises/RateGroupService';

import { rateGroupQueryKeys } from './rateGroupQueryKeys';

type EligibleUngroupedRate = UngroupedRateWithDetails & {
  description: string;
  isNonRefundable: boolean;
};

function canRecommend(rate: UngroupedRateWithDetails): rate is EligibleUngroupedRate {
  return !rate.detailsFetchFailed && rate.description !== null && rate.isNonRefundable !== null;
}

export function useGetRateGroupRecommendations(rates: ReadonlyArray<UngroupedRateWithDetails>, enabled = true) {
  const eligibleRates = rates.filter(canRecommend);

  return useQuery({
    queryKey: rateGroupQueryKeys.recommendations(eligibleRates),
    queryFn: async () => {
      const response = await rateGroupService.getRateGroupRecommendations({
        rates: eligibleRates.map((rate) => ({
          rateId: rate.id,
          description: rate.description,
          rateCodeRemarks: rate.rateCodeRemarks,
          isNonRefundable: rate.isNonRefundable,
          rateCodeDetails: rate.rateCodeDetails,
        })),
      });
      return response.result;
    },
    enabled: enabled && eligibleRates.length > 0,
    retry: false,
    staleTime: Infinity,
  });
}
